import { Trans } from "@coworker/locales";
import dayjs from "dayjs";
import { pascalCase } from "@coworker/components/src/helpers/string.helpers";
import hfbs from "./hfbNumbers.json";

export const AREA_TAB = {
  DEPTS: "depts",
  OTHER: "other",
  WHOLE: "whole",
};

export const periods = [
  {
    type: "period=7days",
    name: <Trans>last7DaysString</Trans>,
    transKey: "last7DaysString",
    getInitialDate: () => dayjs().startOf("day").subtract(6, "days"),
  },
  {
    type: "period=4weeks",
    name: <Trans>last4WeeksString</Trans>,
    transKey: "last4WeeksString",
    getInitialDate: () => dayjs().startOf("week").subtract(3, "weeks"),
  },
  {
    type: "period=custom",
    name: <Trans>customPeriodString</Trans>,
    transKey: "customPeriodString",
  },
];

// Other areas listed alphabetically (more or less - no re-sorting happening as it is tricky to do depending on translations etc.)
export const others =
  `AsIs|Bistro|Checkout|Click and Collect|Customer service area|Entrance (Incl. Greeter)|Financing area|First room|Full Serve Handout|Home Service Point – Planning studio|IKEA for Business|IKEA Restaurant|Ingka Centers|Open the wallet Markethall|Open the wallet Showroom|Parking zone|Pick-up point/hub|Questions from co-workers|Restaurant|Self-serve|Småland|Swedish Food Market`
    .split("|")
    .map((value) => {
      const sanitizedValue = value.replace(/[().]/g, "");
      return {
        type: `${AREA_TAB.OTHER}=${value}`,
        tab: AREA_TAB.OTHER,
        name: <Trans>{`otherArea${pascalCase(sanitizedValue)}String`}</Trans>,
      };
    });

export const departments = hfbs.map((hfbCode: string) => ({
  type: `${AREA_TAB.DEPTS}=${hfbCode}`,
  tab: AREA_TAB.DEPTS,
  shortName: `HFB ${hfbCode}`,
  hfbNumber: hfbCode,
  name: (
    <>
      <>{`HFB${hfbCode} - `}</>
      <Trans>{`hfb${hfbCode}String`}</Trans>
    </>
  ),
}));

export const WHOLE_STORE_FILTER = [
  {
    type: `${AREA_TAB.WHOLE}=${AREA_TAB.WHOLE}`,
    tab: AREA_TAB.WHOLE,
    name: <Trans>wholeStoreString</Trans>,
  },
];

export const areaTabs = [
  {
    key: AREA_TAB.DEPTS,
    name: <Trans>hfbString</Trans>,
    items: departments,
  },
  { key: AREA_TAB.OTHER, name: <Trans>otherString</Trans>, items: others },
  {
    key: AREA_TAB.WHOLE,
    name: <Trans>wholeStoreString</Trans>,
    items: WHOLE_STORE_FILTER,
  },
];
